export default __webpack_public_path__ + "3af2e113027371566cf9778a6ec16ce6.png";